import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared layout wrapper for public legal / support pages.
 * - Dark luxury theme (matches the rest of VelvetGate).
 * - Max-width ~700px for comfortable reading.
 * - Mobile-first padding; wider margins on larger screens.
 * - Small footer nav to the sibling pages.
 */
export default function LegalLayout({ title, effectiveDate, children, testId }) {
  return (
    <div className="min-h-screen bg-[#050505] text-[#EAE7E1]" data-testid={testId}>
      <header className="border-b border-[#1A1A1A]">
        <div className="max-w-[700px] mx-auto px-5 sm:px-6 py-5 flex items-center justify-between">
          <Link to="/" className="text-sm tracking-[0.4em] font-bold text-[#D4AF37] uppercase" data-testid="legal-home-link">VelvetGate</Link>
          <Link to="/" className="text-xs text-[#777] hover:text-[#EAE7E1] transition-colors">← Home</Link>
        </div>
      </header>
      <main className="max-w-[700px] mx-auto px-5 sm:px-6 py-8 sm:py-12">
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-[#F3EEE7] mb-2" data-testid="legal-title">{title}</h1>
        {effectiveDate && (
          <p className="text-xs tracking-wider uppercase text-[#777] mb-8" data-testid="legal-effective-date">Effective Date: {effectiveDate}</p>
        )}
        <div className="prose-vg space-y-6 text-[15px] leading-relaxed text-[#B9B1A6]">
          {children}
        </div>
      </main>
      <nav className="border-t border-[#1A1A1A] mt-12" aria-label="Legal footer">
        <div className="max-w-[700px] mx-auto px-5 sm:px-6 py-6 flex flex-wrap gap-x-5 gap-y-2 text-xs text-[#777]">
          <Link to="/terms"   className="hover:text-[#D4AF37] transition-colors" data-testid="legal-footer-terms">Terms</Link>
          <Link to="/privacy" className="hover:text-[#D4AF37] transition-colors" data-testid="legal-footer-privacy">Privacy</Link>
          <Link to="/faq"     className="hover:text-[#D4AF37] transition-colors" data-testid="legal-footer-faq">FAQ</Link>
          <Link to="/contact" className="hover:text-[#D4AF37] transition-colors" data-testid="legal-footer-contact">Contact</Link>
          <span className="ml-auto text-[#444]">© VelvetGate</span>
        </div>
      </nav>
    </div>
  );
}

/** Numbered section heading used inside legal/support pages. */
export function Section({ n, title, children }) {
  return (
    <section className="pt-2">
      <h2 className="text-lg sm:text-xl font-bold text-[#F3EEE7] mb-2">{n ? `${n}. ${title}` : title}</h2>
      <div className="space-y-3 text-[#B9B1A6]">{children}</div>
    </section>
  );
}
